
const popup = document.querySelectorAll('.ce_rsce_popup');
const body = document.querySelector('body');

if (popup.length > 0){
    checkpopup();
    popup.forEach(popup =>{
        const storageKey = popup.dataset.popupKey || 'popup';
        let closeButton = popup.querySelector('.close');
        let linkButton = popup.querySelector('.button');

        const hidePopup = () => {
            popup.style.display = 'none';
            localStorage.setItem(storageKey, 'false');
        };

        if (closeButton) {
            closeButton.addEventListener('click', hidePopup);
        }

        popup.addEventListener('click', function(event){
            if (event.target === popup || event.target.classList.contains('container')) {
                hidePopup();
            }
        });

        const inner = popup.querySelector('.container-inner');
        if (inner) {
            inner.addEventListener('click', function(event){
                event.stopPropagation();
            });
        }

        if (linkButton) {
            linkButton.addEventListener('click', hidePopup);
        }
    });
}

function checkpopup(){
    try {
        popup.forEach(popup => {
            const storageKey = popup.dataset.popupKey || 'popup';
            const dismissed = localStorage.getItem(storageKey);
            if (dismissed){
                if (window.location.pathname === '/'){
                    popup.style.display = 'block';
                } else if(window.location.pathname.includes('/infotag')) {
                    popup.style.display = 'none';
                } else {
                    popup.style.display = 'none';
                }
            } else {
                if(window.location.pathname.includes('/infotag')) {
                    popup.style.display = 'none';
                } else {
                    popup.style.display = 'block';
                }
            }
        });
    } catch {
        console.log('Cookies deaktiviert');
    } 
}
